<template>
  <footer class="footer has-background-primary has-text-white">
    <div class="gf-container">
      <div class="columns is-vcentered mx-5">
        <div class="column text-left">
          <div>
            <img
              class="logo-img"
              src="../assets/logo-white.png"
              width="250"
              alt="Gigforce logo"
            />
          </div>
          
        
            <button class="button is-primary" @click="goToaboutUs()">Giger</button> <br>
            <!-- <button class="button is-primary" @click="goTosignUp()">Signup</button> <br> -->
            <!-- <button class="button is-primary" @click="goToBusiness()">Business</button><br>
            <button class="button is-primary" @click="goToPartner()">Partner</button> <br> -->
              <button class="button is-primary" @click="goToMedia()">Media</button> <br>
            <button class="button is-primary" @click="goToPrivacyPolicy()">Privacy Policy</button> <br>
            
        </div>

        <div class="column text-left" >
        
        </div>

        

        <div class="column text-left qck-lnks">
          
          <!-- <div class="head is-size-4">Quick Links</div>
        <div class="mt-2">
          <ul>
             <li><button class="button is-primary">About Us</button></li>
             <li><button class="button is-primary">Blog</button></li>
             <li><button class="button is-primary">Contact</button></li>
             <li><button class="button is-primary">FAQ</button></li>
          </ul>
        </div> -->
        </div>

        <div class="column text-left">
          <!-- <ul>
           <li><button class="button is-primary">Disclaimer</button></li>
           <li><button class="button is-primary">Privacy Policy</button></li>
           <li><button class="button is-primary">Terms of Service</button></li>
        </ul> -->
        </div>

        <div class="column text-left">
          <p class="mt cnt-us">Connect us at :</p>
          <p >hello@gigforce.in</p>
          <span class="social-icons">
            <a href="https://www.facebook.com/gig4ce" target="_blank"
              ><img src="img/social/facebook.svg" alt="fb"
            /></a>
            <a href="https://www.linkedin.com/company/gigforce/" target="_blank"
              ><img src="img/social/linkedin.svg" alt="ln"
            /></a>
            <a href="https://twitter.com/gig4ce" target="_blank"
              ><img src="img/social/twitter.svg" alt="tw"
            /></a>
          </span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
var VueScrollTo = require("vue-scrollto");

export default {
  methods: {
     goToHome() {
        this.$router.push({ name: "Home" });
        setTimeout(() => {
          VueScrollTo.scrollTo("", 1000);
        }, 500);
      },


    goToaboutUs() {
        this.$router.push({ name: "Home" });
        setTimeout(() => {
          VueScrollTo.scrollTo("#aboutUs", 1000);
        }, 500);
      },

    goToBusiness() {
      this.$router.push({ name: "business" });
      setTimeout(() => {
        VueScrollTo.scrollTo("#business", 1000);
      }, 500);
    },

     goToPartner() {
      this.$router.push({ name: "partners" });
      setTimeout(() => {
        VueScrollTo.scrollTo("#partners", 1000);
      }, 500);
    },

      goToPrivacyPolicy() {
      this.$router.push({ name: "privacypolicy" });
      setTimeout(() => {
        VueScrollTo.scrollTo("#privacypolicy", 1000);
      }, 500);
    },
    
    goToMedia()
    {
      this.$router.push({ name: "Media" });
      setTimeout(() => {
        VueScrollTo.scrollTo("#media", 1000);
      }, 500);
    },
    goTosignUp() {
        this.$router.push({ name: "Signup" });
        setTimeout(() => {
          VueScrollTo.scrollTo("#sign-up", 1000);
        }, 500);
      },
  },
};
</script>
<style lang="scss">
.footer {
  background-image: linear-gradient(
    135deg,
    rgb(215, 31, 99) 0%,
    rgb(140, 0, 124) 100%
  );
  .link {
    display: block;
  }
  .qck-lnks {
    margin-top: 40px;
  }

  .button {
    background: transparent;
    font-size: 16px;
  }

  .head {
    font-size: 25px;
    font-weight: 700;
  }

  .mt-2 {
    margin-top: 15px;
  }
  .cnt-us {
    font-size: 16px;
    font-weight: bold;
  }
  .social-icons img {
    margin-top: 10px;
    margin-right: 18px;
    width: 10%;
  }
  .logo-img {
    margin-bottom: 42px;
  }
  .head {
    font-size: 20px !important;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px){
  .footer .social-icons img{
   width: 5%;
 }
}
</style>
